import { DriverQualificationsType } from 'app/constants/driverQualificationsType'

export const getDriverQualificationTypeName = (
  type: DriverQualificationsType,
  translate: (string) => string,
): string => {
  const stringType: string = DriverQualificationsType[type]
  return translate(`driverQualification.${stringType}`)
}
